import { Box, CircularProgress } from '@mui/material';

export function FullPageLoader({ label }: { label?: string }) {
  return (
    <Box
      role="status"
      aria-label={label ?? 'Loading'}
      sx={{ minHeight: '60vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2 }}
    >
      <CircularProgress />
    </Box>
  );
}
